//user模块，存储/操作user相关数据
export default {
    namespaced: true,
    state: () => ({
        token: '',
        crowd: '',
        info: '',
        pcInfo: '',
        homepage:''
        // cachedViews: [], //页面缓存数组
    }),

    actions: {
        // 请求数据函数
        setToken(context, value) {
            console.log(context, value);
            context.commit('SETTOKEN', value)
        },
        setCrowd(context, value) {
            console.log(context, value);
            context.commit('SETCROWD', value)
        },
        setUserInfo(context, value) {
            console.log(context, value);
            context.commit('SETUSERINFO', value)
        },
        setPcInfo(context, value) {
            console.log(context, value);
            context.commit('SETPCINFO', value)
        },
        setHomePage(context, value) {
            console.log(context, value);
            context.commit('SETHOMEPAGE', value)
        },
        // //添加页面缓存
        // addCachedView(context, value) {
        //     console.log(context, value);
        //     context.commit('ADD_CACHED_VIEW', value)
        // },
        // //清空页面缓存
        // delCachedView(context) {
        //     console.log(context);
        //     context.commit('DEL_CACHED_VIEW')
        // }
    },
    mutations: {
        // 改数据函数
        SETTOKEN(context, value) {
            context.token = value
        },
        SETCROWD(context, value) {
            context.crowd = value
        },
        SETUSERINFO(context, value) {
            context.info = value
        },
        SETPCINFO(context, value) {
            context.pcInfo = value
        },
        SETHOMEPAGE(context, value) {
            context.homepage = value
        },
        // //添加页面缓存
        // ADD_CACHED_VIEW: (context, value) => {
        //     let x = context.cachedViews.includes(value) ? true : false
        //     if(!x) {
        //         context.cachedViews.push(value)
        //     }
        // },
        // //清空页面缓存
        // DEL_CACHED_VIEW: (context) => {
        //     context.cachedViews = []
        // }
    },
}